import React, { useCallback, useRef } from 'react';

import Button from '@material-ui/core/Button';
import VideoOffIcon from '../../../icons/VideoOffIcon';
import VideoOnIcon from '../../../icons/VideoOnIcon';

import useDevices from '../../../hooks/useDevices/useDevices';
import useLocalVideoToggle from '../../../hooks/useLocalVideoToggle/useLocalVideoToggle';
import Tooltip from '@material-ui/core/Tooltip';
import { useAppState } from '../../../state';

export default function ToggleVideoButton(props: { disabled?: boolean; className?: string }) {
  const { user } = useAppState();
  const [isVideoEnabled, toggleVideoEnabled, disableVideo] = useLocalVideoToggle();
  const lastClickTimeRef = useRef(0);
  const { hasVideoInputDevices } = useDevices();

  const toggleVideo = useCallback(() => {
    if (Date.now() - lastClickTimeRef.current > 500) {
      lastClickTimeRef.current = Date.now();
      toggleVideoEnabled();
    }
  }, [toggleVideoEnabled]);

  React.useEffect(() => {
    if (user?.isMuted) {
      disableVideo();
    }
  }, [isVideoEnabled, user?.isMuted, toggleVideoEnabled]);

  return (
    <Tooltip title="Kamera ki-be kapcsolása">
      <Button
        className={props.className}
        onClick={toggleVideo}
        disabled={!hasVideoInputDevices || props.disabled || user?.isMuted}
      >
        {!hasVideoInputDevices ? '' /*'No Video'*/ : isVideoEnabled ? /*'Stop Video' : 'Start Video'*/ '' : ''}
        {isVideoEnabled ? <VideoOnIcon /> : <VideoOffIcon />}
      </Button>
    </Tooltip>
  );
}
